import {
  prepareDataForApolloCache,
  QueryInfo,
} from '../prepareDataForApolloCache';
import { MutationAddButlerButtonArgs } from '../generated';
import { token } from '@trello/session-cookie';
import { clientVersion } from '@trello/config';
import { parseNetworkError } from '@trello/graphql-error-handling';

export const addButlerButton = async (
  obj: object,
  args: MutationAddButlerButtonArgs,
  context: object,
  info: QueryInfo,
) => {
  // Scope must be 'boards' | 'organizations'.
  const response = await fetch(
    `/1/${args.scope}/${args.idScope}/butlerButtons`,
    {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Trello-Client-Version': clientVersion,
      },
      body: JSON.stringify({
        ...args.butlerButton,
        token,
      }),
    },
  );

  if (!response.ok) {
    throw await parseNetworkError(response);
  }

  return prepareDataForApolloCache(await response.json(), info);
};
